<template>
  <b-container>
    <vue-headful :title="setPageTitle('assetClassUnavailable')" />
    <b-row>
      <b-col>
        <div class="d-flex text-center text-muted vertical-center">
          <div class="w-100">
            <i class="fas fa-ban unavailable-icon mb-3"></i>
            <h5 class="text-dark">{{ $t('assetClassUnavailable.title') }}</h5>
            <p class="mb-4 text-dark">
              {{ $t('assetClassUnavailable.message', { assetClass: assetClassName(selected) }) }}
            </p>
            <b-button
              v-for="slug in alternatives"
              :key="slug"
              class="mr-2 mb-2"
              size="sm"
              variant="primary"
              @click="openIn(slug)"
            >
              {{ $t('assetClassUnavailable.openIn', { assetClass: assetClassName(slug) }) }}
            </b-button>
            <b-button class="mb-2" size="sm" variant="outline-primary" @click="goHome()">
              <i class="fas fa-chevron-left mr-1"></i> {{ $t('assetClassUnavailable.goHome') }}
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { openInAssetClass } from '../../utils/assetClassSwitch'

export default {
  name: 'AssetClassUnavailable',

  props: {
    // Route-relative path the user asked for, e.g. /efficiencyTestsList.
    from: {
      type: String,
      default: '',
    },
  },

  computed: {
    selected() {
      return this.$store.getters.getSelectedAssetClass
    },
    // The page that was refused says what it needed: the asset classes that grant it are offered.
    requiredPermission() {
      const meta = this.from ? this.$router.resolve(this.from).route.meta : null
      return (meta && meta.requires) || null
    },
    alternatives() {
      if (!this.requiredPermission) {
        return []
      }
      return this.$store.getters.getAvailableAssetClasses.filter(
        (slug) => slug !== this.selected && this.$store.getters.can(this.requiredPermission, slug)
      )
    },
  },

  methods: {
    assetClassName(slug) {
      return this.$t(`navbar.assetClass.${slug}.name`)
    },
    openIn(slug) {
      openInAssetClass({ store: this.$store }, slug, this.from)
    },
    goHome() {
      this.$router.push({ name: 'index' })
    },
  },
}
</script>

<style lang="scss" scoped>
.vertical-center {
  min-height: calc(100% - 45px - 60px); /* Fallback for browsers do NOT support vh unit */
  min-height: calc(100vh - 45px - 60px); /* These two lines are counted as one */
  align-items: center;
}
.unavailable-icon {
  font-size: 4rem;
  color: var(--gray6);
}
</style>
